import React, { useEffect, useState } from 'react';
import { ToastContainer } from 'react-toastify';
import { getCityWithPreposition } from '../../../utils/functions/getCityWithPreposition';
import useAppContext from '../../../hooks/useAppContext';
import { AppContextType } from '../../../context/AppContext';
import { CompanyNameType } from '../../../static/types/commonTypes/companyNameType';
import { DecisionType } from '../../../static/types/commonTypes/decisionType';
import CompanyName from '../../commonComponents/CompanyName';
import LegalEntity from '../../commonComponents/LegalEntity';
import { LegalEntityType } from '../../../static/types/commonTypes/legalEntityType';
import { SlArrowLeft, SlArrowRight } from "react-icons/sl";
import { FaUpload } from 'react-icons/fa';
import { GoArrowRight } from 'react-icons/go';
import DecisionWithQuality from '../../commonComponents/DecisionWithQuality';
import { formatObjectText } from '../../../utils/functions/formatObjectText';


interface AnnonceProps {
    txtAnnonce: string;
    updateTxtAnnonce: (newTxt: string) => void;
    updateDenomination: (newTxt: string) => void;
    activeIndex: number;
    updateActiveIndex: (index: number) => void;
    societyType: string | string[];
    societeSelected: string;
    updatesocieteSelected: (newTxt: string) => void;
}
const ChangementDenomination: React.FC<AnnonceProps> = ({
    txtAnnonce,
    updateDenomination,
    updateTxtAnnonce,
    updateActiveIndex,
    societyType
}) => {

    const {
        companyName, setCompanyName,
        companyNameValidity, setCompanyNameValidity,
        companyNameChecked, setCompanyNameChecked,

        decisionWithQualityAndEffectiveDate,
        setDecisionWithQualityAndEffectiveDate,
        decisionWithQualityAndEffectiveDateValidity,
        setDecisionWithQualityAndEffectiveDateValidity,
        decisionWithQualityAndEffectiveDateChecked,
        setDecisionWithQualityAndEffectiveDateChecked,

        legalEntity, setLegalEntity,
        legalEntityValidity, setLegalEntityValidity,
        legalEntityChecked, setLegalEntityChecked,

        companyNameUpdate, setCompanyNameUpdate,
        companyNameUpdateValidity, setCompanyNameUpdateValidity,
        companyNameUpdateChecked, setCompanyNameUpdateChecked,

        lastTab, setLastTab

    } = useAppContext() as AppContextType

    const updateCompanyName = (data: Partial<CompanyNameType>) => setCompanyName({ ...companyName, ...data });

    const updateDecision = (data: Partial<DecisionType>) => setDecisionWithQualityAndEffectiveDate({ ...decisionWithQualityAndEffectiveDate, ...data });

    const societyTypeOptions = Array.isArray(societyType) ? societyType : [societyType]

    const updateCompanyNameUpdate = (data: Partial<CompanyNameType>) => setCompanyNameUpdate({ ...companyNameUpdate, ...data });

    const [submissive, setSubmissive] = useState<boolean>(false)

    const [activeTab, setActiveTab] = useState<string>('raisonSociale');
    const [visitedTabs, setVisitedTabs] = useState(['raisonSociale']);

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        if (validate()) {
            const pluralSubjects = ["Les associés","Les actionnaires"];

            const verb = pluralSubjects.includes(decisionWithQualityAndEffectiveDate.decisionQuality) ? "ont" : "a";

            const tempText = `${companyName.companyName},
${legalEntity.legalForm} au capital de ${legalEntity.capital} €,
Siège social :
${legalEntity.address} ${legalEntity.additionalAddress ?? ""} ${legalEntity.postalCode} ${legalEntity.city}
${legalEntity.rcs} RCS ${getCityWithPreposition(legalEntity.registrationOffice)}
${firstPartDecision.includes(decisionWithQualityAndEffectiveDate.decisionNature) ? `Aux termes de l'${decisionWithQualityAndEffectiveDate.decisionNature} en date du ${decisionWithQualityAndEffectiveDate.decisionDate} ${decisionWithQualityAndEffectiveDate.decisionQuality} ${verb}`: `Le ${decisionWithQualityAndEffectiveDate.decisionDate} ${decisionWithQualityAndEffectiveDate.decisionNature.toLowerCase()} ${verb}`
} décidé de modifier la dénomination sociale qui devient${decisionWithQualityAndEffectiveDate.effectiveDate ? ` à compter du ${decisionWithQualityAndEffectiveDate.effectiveDate}` : "" } : ${companyNameUpdate.companyName},
Mention au RCS ${getCityWithPreposition(legalEntity.registrationOffice)}.`

            const formattedText = formatObjectText(tempText);
            updateTxtAnnonce(formattedText);
            updateDenomination(companyName.companyName);
        }
    };

    const firstPartDecision = [
        "AG Extraordinaire",
        "AG Ordinaire",
        "AG Mixte"
    ]

    const handleNext = () => {
        if (activeTab === "raisonSociale") {
            setCompanyNameChecked(true)
            if (companyNameValidity) {
                switchTab(getNextTab("raisonSociale"));
            }
        } else if (activeTab === "decision") {
            setDecisionWithQualityAndEffectiveDateChecked(true)
            if (decisionWithQualityAndEffectiveDateValidity) {
                switchTab(getNextTab("decision"));
            }
        } else if (activeTab === "theSociety") {
            setLegalEntityChecked(true)
            if (legalEntityValidity) {
                switchTab(getNextTab("theSociety"));
            }
        } else if (activeTab === "companyNameUpdate") {
            setCompanyNameUpdateChecked(true)
            if (companyNameUpdateValidity) {
                setSubmissive(true)
            }
        }
    };

    const handlePrevious = () => {
        switchTab(getPreviousTab(activeTab));
        setSubmissive(false);
    };
    
    useEffect(() => {
        // Si on vient d'un brouillon, restaurer l'onglet actif
        if ( lastTab ) {
            setActiveTab(lastTab);
            // Ajouter tous les onglets précédents comme visités
            const tabOrder = ['raisonSociale', 'decision', 'theSociety', 'companyNameUpdate'];
            const currentTabIndex = tabOrder.indexOf(lastTab);
            const visitedTabsArray = tabOrder.slice(0, currentTabIndex + 1);
            setVisitedTabs(visitedTabsArray);
        }
    }, []);

    useEffect(() => {
        setLastTab(activeTab);
    }, [activeTab]);

    const getNextTab = (currentTab: string) => {
        if (currentTab === "raisonSociale") return "decision";
        else if (currentTab === "decision") return "theSociety";
        else if (currentTab === "theSociety") return "companyNameUpdate";
        else return currentTab;
    };

    const getPreviousTab = (currentTab: string) => {
        if (currentTab === "companyNameUpdate") return "theSociety";
        else if (currentTab === "theSociety") return "decision";
        else if (currentTab === "decision") return "raisonSociale";
        else return currentTab;
    };

    const validate = () => {
        if (!companyNameValidity) {
            setActiveTab("raisonSociale")
        } else if (!decisionWithQualityAndEffectiveDateValidity) {
            setActiveTab("decision")
        } else if (!legalEntityValidity) {
            setActiveTab("theSociety")
        } else if (!companyNameUpdateValidity) {
            setActiveTab("companyNameUpdate")
        }

        return companyNameValidity && decisionWithQualityAndEffectiveDateValidity && legalEntityValidity && companyNameUpdateValidity
    };


    const switchTab = (tab: string) => {
        if (!visitedTabs.includes(tab)) {
            setVisitedTabs([...visitedTabs, tab]);
        }
        setActiveTab(tab);
    }

    const goToSupportPresse = () => {
        updateActiveIndex(2);
    }

    const tabs =[
        {key: 'raisonSociale', label: 'Raison Sociale'},
        {key: 'decision', label: 'La décision'},
        {key: 'theSociety', label: 'La société'},
        {key: 'companyNameUpdate', label: 'Nouvelle dénomination'}
    ]

    return (
        <>
                <div className="container my-3">
                <ul className="nav nav-underline">
                    {tabs
                    .filter((t) => t.key === activeTab) 
                    .map((t) => (
                        <li className="nav-item" key={t.key}>
                        <a
                            href={`#${t.key}`}
                            className={`nav-link active`} 
                        >
                            {t.label}
                        </a>
                        </li>
                    ))}
                    </ul>
                </div>

            <ToastContainer />

            <form onSubmit={handleSubmit}>
                {
                    activeTab === 'raisonSociale' &&
                    <div>
                        <span className='mb-2'>
                            Indiquer la raison sociale de la société ou la dénomination du Cabinet de Notaire annonceur ou l'état civil de la personne concernée par l'annonce, en optionnel vous pouvez ajouter une référence client.
                        </span>
                        <div className="tab-content">
                            <CompanyName
                                changeCompanyName={updateCompanyName}
                                checked={companyNameChecked}
                                companyName={companyName}
                                onValidationChange={(isValid: boolean) => setCompanyNameValidity(isValid)}
                                showClientReference={true}
                            />
                        </div>

                    </div>
                }

                {
                    activeTab === 'decision' &&
                    <DecisionWithQuality
                        decisionWithQuality={decisionWithQualityAndEffectiveDate}
                        draftFieldName = 'decisionWithQualityAndEffectiveDate'
                        checked={decisionWithQualityAndEffectiveDateChecked}
                        dateLabel='Date'
                        changeDecision={updateDecision}
                        onValidationChange={(isValid: boolean) => setDecisionWithQualityAndEffectiveDateValidity(isValid)}
                        decisionQualityOptions={[
                            "L'associé unique",
                            "Les associés",
                            "Les actionnaires"
                        ]}
                        decisionNatureOptions={[
                            "AG Extraordinaire",
                            "AG Ordinaire",
                            "AG Mixte",
                            "Le gérant",
                            "Le président",
                            "Le conseil d'administration",
                            "Décision unanime des associés"
                        ]}
                    />
                }

                {
                    activeTab === 'theSociety' &&
                    <LegalEntity
                        changeLegalEntity={(partialData: Partial<LegalEntityType>) => setLegalEntity({ ...legalEntity, ...partialData })}
                        checked={legalEntityChecked}
                        legalEntity={legalEntity}
                        onValidationChange={(isValid: boolean) => setLegalEntityValidity(isValid)}
                        companyName={companyName}
                        setCompanyName={(partialData: Partial<CompanyNameType>) => setCompanyName({ ...companyName, ...partialData })}
                        societyType={societyTypeOptions}
                        draftFieldName = 'legalEntity'
                    />
                }

                {
                    activeTab === 'companyNameUpdate' &&
                    <div className="row">
                        <CompanyName
                            changeCompanyName={updateCompanyNameUpdate}
                            companyName={companyNameUpdate}
                            draftFieldName = 'companyNameUpdate'
                            checked={companyNameUpdateChecked}
                            onValidationChange={(isValid: boolean) => setCompanyNameUpdateValidity(isValid)}
                            showClientReference={false}
                        />
                        {
                            submissive &&
                            <div className="mt-4">
                                <h4>Texte de l'annonce:</h4>
                                <textarea
                                    className="form-control"
                                    rows={5}
                                    value={txtAnnonce}
                                    disabled
                                />
                            </div>
                        }
                    </div>
                }

                <div className="button-container">
                    <div className="d-flex gap-2">
                        {
                            activeTab !== 'raisonSociale' && (
                                <button color="#F4A261"
                                    className="btn-add"
                                    type="button"
                                    onClick={handlePrevious} >
                                    <SlArrowLeft className="icon" style={{ marginRight: '10px', fontSize: '20px' }} />
                                    Modifier mon annonce
                                </button>
                            )}

                        {
                            activeTab === 'companyNameUpdate' && (
                                <button type="submit"
                                    onClick={handleNext}>
                                    Mettre à jour mon annonce
                                    <FaUpload className="icon" style={{ marginLeft: '15px', fontSize: '20px' }} />
                                </button>
                            )}

                        {
                            activeTab !== 'companyNameUpdate' && (
                                <button color="#F4A261"
                                    className="btn-add"
                                    type="button"
                                    onClick={handleNext} >
                                    Suivant
                                    <SlArrowRight className="icon" style={{ marginLeft: '10px', fontSize: '20px' }} />
                                </button>
                            )}

                        {
                            submissive && activeTab === 'companyNameUpdate' && (
                                <button color="#F4A261"
                                    className="btn-add"
                                    type="button"
                                    onClick={goToSupportPresse} >
                                    Sélection du support
                                    <GoArrowRight className="icon" style={{ marginLeft: '10px', fontSize: '20px' }} />
                                </button>
                            )}
                    </div>
                </div>
            </form>
        </>
    );
};

export default ChangementDenomination;